
export default {

    //login page
    //right section
    tagline: "سمارٹ کام یہاں شروع ہوتا ہے۔",
    subtext: "اپنی فیلڈ آپریشنز کو بہتر بنانے کے لیے لاگ ان کریں۔",

    //left section
    emailLabel: "ای میل",
    passwordLabel: "پاس ورڈ",
    emailPlaceholder: "ای میل",
    passwordPlaceholder: "پاس ورڈ",
    forgotPassword: "پاس ورڈ بھول گئے؟",
    forgotPasswordTip: "فکر نہ کریں! اپنا ای میل درج کریں تاکہ اپنا پاس ورڈ محفوظ طریقے سے ری سیٹ کریں",
    signIn: "سائن ان کریں",
    copyrightText: "کاپی رائٹ فیلڈ فورس",
    returnToLogin: "لاگ ان پر واپس جائیں",
    enterOTPAndResetPassword: "اپنا 6 ہندسوں کا OTP درج کریں جو آپ کے ای میل پر بھیجا گیا ہے، اور ایک منفرد اور مضبوط پاس ورڈ بنائیں",



    //sidebar 
    //menus
    dashboard: "ڈیش بورڈ",
    analytics: "تجزیات",
    forms: "فارمز",
    logout: "لاگ آؤٹ",

    //task and its sub menus
    task: "کام",
    taskList : "کاموں کی فہرست",
    planner:  "پلانر",
    locate: "ٹیم تلاش کریں",
    taskTarget: "کاموں کا ہدف",
    archiveTask: "محفوظ شدہ کام",

    //manage and its sub menu
    manage: "مینج",
    visitProfile : "وزٹ پروفائل",
    employee : "ملازم",
    permissions : "اجازتیں",
    status : "سٹیٹس",
    searchHere : "یہاں تلاش کریں....",
    permissionGroup : "اجازت گروپ",
    officeLocation : "دفتر کا مقام",
    team: "ٹیم",
    product : "مصنوعات",
    designation: "عہدہ",
    designationLevel: "عہدہ کی سطح",
    doctor: "ڈاکٹر",
    department: "شعبہ",
    doctorSpecialization: "ڈاکٹر کی مہارت",
    doctorDesignation: "ڈاکٹر کا عہدہ",
    practiceLocation: "عملی مقام",
    practiceLocationType: "عملی مقام کی قسم",
    locationType: "مقام کی قسم",
    employmentStatus: "ملازمت کی حیثیت",
    customerRank: "کسٹمر درجہ",
    subTask: "ذیلی کام",
    taskStatus: "کام کی حالت",
    taskType: "کام کی قسم",
    taskPriority: "کام کی ترجیح",
    city: "شہر",
    country: "ملک",
    role: "کردار",
    specialization: "مہارت",
    getOTP: "OTP حاصل کریں",

    //components

    downloadSummary: "خلاصہ ڈاؤن لوڈ کریں",
 
    addTask: "کام کا اندراج کریں",
    viewNotes: "نوٹس دیکھیں",
    taskDetails: "کام کی تفصیلات",

    addNew: "نیا اندراج کریں",
    filters: "فلٹرز",
    hide: "چھپائیں",
    search: "تلاش کریں",
    of: "میں سے",
    practiceLocation: "پریکٹس کی جگہ",
    priority: "ترجیح",
    visitDate: "ملاقات کی تاریخ",
    accompaniedBy: "ہمراہ (اختیاری)",
    assignTo: "اسائن ٹو",
    assignedTo: "اسائن ٹو",
    assignedBy: "تفویض کردہ",
    assignToMe: "اسائن ٹو می",
    name: "نام",
    shortName: "مختصر نام",
    firstName: "پہلا نام",
    lastName: "آخری نام",
    doctorName: "ڈاکٹر کا نام",
    personalContact: "ذاتی رابطہ نمبر",
    contact: "رابطہ نمبر",
    dateOfJoining: "شمولیت کی تاریخ",
    cnicNo: "شناختی کارڈ نمبر",
    gender: "جنس",
    passportNo: "پاسپورٹ نمبر",
    personalEmail: "ذاتی ای میل",
    address: "پتہ",
    headOffice: "ہیڈ آفس",
    displayName: "ظاہری نام",
    createdOn: "تخلیق کی تاریخ",
    visitDate: "ملاقات کی تاریخ",
    visitProfile: "وزٹ پروفائل",
    reportsTo: "رپورٹس ٹو",
    officialDetails: "ملازمت کی تفصیلات",
    description: "تفصیل",
    active: "چالو ؟",
    save: "محفوظ کریں",
    cancel: "منسوخ کریں",
    addAnother: "ایک اور ",
    addDoctor: "ڈاکٹر کا اندراج کریں",
    submitPlan: "پلان بھیجیں",
    myPlan: "میرا پلان",
    month: "مہینہ",
    week: "ہفتہ",
    day: "دن",
    selectEmployee: "ملازم منتخب کریں",
    personalDetails: "ذاتی تفصیلات",
    addEmployee: "ملازم شامل کریں",
    clearAll: "فلٹر ہٹائیں",
    myTasks: "میرے کام",
    subOrdinates: "ذیلی اہلکار",
    newPassword: "نیا پاس ورڈ",
    confirmPassword: "پاس ورڈ کی تصدیق کریں",
    emailNotReceivedTip: "اگر آپ کو 5 منٹ میں ای میل موصول نہیں ہوئی، تو اسپیم فولڈر چیک کریں",
    resendOTP: "OTP دوبارہ بھیجیں",
    tryAgain: "دوبارہ کوشش کریں",
    or: "یا",
    submit: "جمع کرائیں",
    noDataFound: "کوئی ڈیٹا نہیں ملا",
    onLeave: "چھٹی پر",
    enterLeaveMessage: "اپنا چھٹی کا پیغام یہاں درج کریں",
    leaveMessage: "چھٹی کا پیغام",
    visitTime: "وزٹ کا وقت",
    start: "شروع",
    end: "اختتام",
    callAverage: "کال ایوریج",
    callAverageByTable: "کال ایوریج بائے ٹیبل",
    callAverageByEmployee: "کال ایوریج بائے ایمپلائی",
    callAverageByProduct: "کال ایوریج بائے پروڈکٹ",
    callAverageByPracticeLocation: "کال ایوریج بائے پریکٹس لوکیشن",
    kol: "کول",
    activeEmployee: "ایکٹیو ایمپلائی",
    totalDoctors: "ٹوٹل ڈاکٹرز",
    visitProfiles: "وزٹ پروفائلز",
    practiceLocations: "پریکٹس لوکیشنز",
    createdBy: "کری ایٹڈ بائے",
    lastLogin: "لاسٹ لاگ ان",
    lastUpdated: "لاسٹ اپڈیٹڈ",
    action: "ایکشن",
    title: "ٹائٹل",

    addVisitProfile: "وزٹ پروفائل کا اندراج کریں",
    addPermissionGroup : "اجازت کا گروپ شامل کریں",
    addPermissionGroupTip: "رسائی کی سطح اور اجازتوں کی وضاحت کریں",
    addOfficeLocation: "دفتر کا مقام شامل کریں",
    addOfficeLocationTip: "کمپنی کے دفتر کے مقام کی تفصیلات درج کریں",
    addTeam: "ٹیم شامل کریں",
    addTeamTip: "صارفین کو منظم کرنے اور تعاون کو مؤثر بنانے کے لیے ٹیمیں بنائیں",
    addProduct: "پروڈکٹ شامل کریں",
    addProductTip: "پروڈکٹ کی معلومات اور متعلقہ دستاویزات درج کریں",
    addDesignation: "عہدہ شامل کریں",
    addDesignationTip: "تنظیم میں ملازمت کے عہدے مقرر اور منظم کریں",
    addDepartment: "محکمہ شامل کریں",
    addDepartmentTip: "نیا محکمہ بنائیں اور ٹیم کی تعیناتیاں منظم کریں",
    addDoctorDesignation: "ڈاکٹر کا عہدہ شامل کریں",
    addDoctorDesignationTip: "نیا ڈاکٹر کا عہدہ درج کریں",
    addDoctorSpecialization: "ڈاکٹر کی تخصص شامل کریں",
    addDoctorSpecializationTip: "ڈاکٹروں کے لیے مہارت کا نیا شعبہ متعین کریں",
    addPracticeLocation: "پریکٹس کا مقام شامل کریں",
    addPracticeLocationTip: "نیا پریکٹس مقام درج کریں",
    addCustomerRank: "کسٹمر درجہ شامل کریں",
    addCustomerRankTip: "کسٹمر کو درجہ بندی کے لیے ایک درجہ متعین کریں",
    addSubTasks: "ذیلی کام شامل کریں",
    addSubTasksTip: "بڑے کام کے اندر ایک چھوٹا، قابلِ انتظام کام بنائیں",
    addCity: "شہر شامل کریں",
    addCityTip: "نیچے ایک شہر درج کریں",
    addRole: "کردار شامل کریں",
    addRoleTip: "کردار متعین کریں اور متعلقہ اجازت گروپ درج کریں",
    addEmploymentStatus: "ملازمت کی حیثیت شامل کریں",
    addEmploymentStatusTip: "ملازمت کی حیثیت متعین کریں",
    addTaskPriority: "کام کی ترجیح شامل کریں",
    addTaskPriorityTip: "کام کی تکمیل کو ترجیح دینے کے لیے ہنگامی سطح مقرر کریں",
    pastePlan: "پلان چسپاں کریں",
    pastePlanTip: "یہ آپ کی کاپی کی گئی تاریخیں ہیں، ضرورت ہو تو ہدف تاریخ پر کلک کر کے تبدیل کریں",
    paste: "چسپاں کریں",
    pasteMonthlyPlanConfirm: "آپ ماہانہ پلان چسپاں کرنے والے ہیں۔ یہ عمل اس ماہ میں پہلے سے شامل کردہ دوروں کو اوور رائڈ کر دے گا، کیا آپ واقعی جاری رکھنا چاہتے ہیں؟",
    addItem: "نیا {{item}} شامل کریں",
    createNewItemRecord: "نیا {{item}} ریکارڈ بنائیں",
    jobLocation: "جاب لوکیشن",
    officialEmail: "آفیشل ای میل",
    officialContact: "آفیشل کانٹیکٹ",
    employeeId: "ایمپلائی آئی ڈی",
    applyFilters: "فلٹرز لگائیں",
    select: "سلیکٹ",
    from: "فروم",
    to: "ٹو",
    noDataMessage: "دکھانے کے لیے کوئی ڈیٹا نہیں۔ 'فلٹرز لگائیں یا تبدیل کریں",
    custom: "کسٹم",
    apply: "لگائیں",
    reset: "ری سیٹ",
    date: "تاریخ",
    calls: "کالز",
    notes: "نوٹس",
    enterTaskNote: "ٹاسک نوٹ درج کریں",
    taskNote: "ٹاسک نوٹ",
    addNote: "نوٹ شامل کریں",
    attachments: "اٹیچمنٹس",
    statusHistory: "اسٹیٹس ہسٹری",
    add: "اندراج",
    type: "قسم",
    levelOrder: "لیول آرڈر",
    addDesignationLevel: "عہدے کی سطح شامل کریں",
    addDesignationLevelTip: "یہ عہدے کی درجہ بندی میں سطح کو متعین کرے گا",
    lowerNumberHierarchyTip: "کم نمبر درجہ بندی میں اعلیٰ سطح کو ظاہر کرتے ہیں۔",
    color: "رنگ",
    addCities: "شہر شامل کریں",
    addCitiesTip: "نیچے ایک شہر درج کریں۔",
    attachedDocuments: "اٹیچڈ ڈاکیومنٹس",
    noFilesAttached: "کوئی فائل اٹیچ نہیں ہے",
    clickToUpload: "اپلوڈ کرنے کے لیے کلک کریں",
    acceptedFormats: "قبول شدہ فارمیٹس",
    viewDetails: "تفصیلات دیکھیں",
    total: "کل",
    created: "تخلیق شدہ",
    inReview: "جائزہ میں",
    approved: "منظور شدہ",
    inProgress: "جاری ہے",
    rejected: "مسترد",
    cancelled: "منسوخ",
    onHold: "زیرِ التواء",
    reScheduled: "دوبارہ شیڈول",
    completed: "مکمل",
    doctorUnavailable: "ڈاکٹر دستیاب نہیں",
    refusedToMeet: "ملنے سے انکار",
    visitComplete: "وزٹ مکمل",
    submitted: "جمع شدہ",
    submitPlan: "پلان جمع کریں",
    submitPlanTip: "جمع کرانے کے بعد آپ تبدیلیاں نہیں کر سکیں گے، کیا آپ واقعی جاری رکھنا چاہتے ہیں؟",
    approvePlan: "پلان منظور کریں",
    approvePlanTip: "کیا آپ واقعی اس ماہانہ پلان کو منظور کرنا چاہتے ہیں؟ آپ کا فیصلہ اس ملازم کے لیے جائزہ کو حتمی شکل دے گا۔",
    rejectPlan: "پلان مسترد کریں",
    rejectPlanTip: "کیا آپ واقعی اس ماہانہ پلان کو مسترد کرنا چاہتے ہیں؟ ملازم کو پلان پر دوبارہ نظر ثانی کر کے جائزے کے لیے دوبارہ جمع کرانا ہوگا۔",
    approve: "منظور",
    addSuggestionsHere: "یہاں تجاویز شامل کریں",
    noRejectionNotes: "کوئی مسترد کرنے کے نوٹس دستیاب نہیں",
    rejectionNotes: "مسترد نوٹس",

    time: "وقت",
    update: "اپ ڈیٹ",
    map: "نقشہ",
    chooseLocation: "مقام منتخب کریں",
    loadingMap: "نقشہ لوڈ ہو رہا ہے",
    displayAddress: "ڈسپلے ایڈریس",
    enterDisplayAddress: "ڈسپلے ایڈریس درج کریں",

    // Travel Summary
    travelSummary: "سفر کا خلاصہ",
    totalDistance: "کل فاصلہ",
    totalFuelCost: "کل ایندھن کی لاگت",
    fuelRate: "ایندھن کی شرح",
    vehicleAverage: "گاڑی کا اوسط",
    edit: "ترمیم",
    editFuelRate: "ایندھن کی شرح میں ترمیم",
    editVehicleAverage: "گاڑی کے اوسط میں ترمیم",
    pricePerLiter: "فی لیٹر قیمت",
    averageKmPerLiter: "اوسط (km/L)",
    distance: "فاصلہ",
    fuel: "ایندھن",
    input: "درج کریں",
    invalidFuelRate: "براہ کرم 0 سے زیادہ درست ایندھن کی شرح درج کریں",
    invalidVehicleAverage: "براہ کرم 0 سے زیادہ درست گاڑی کا اوسط درج کریں",
    viewSubordinates: "ماتحت ملازمین دیکھیں",
    allSubordinates: "تمام ماتحت ملازمین",
};